import { Component, inject } from '@angular/core';
import { SpeciesGroupPlantTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpeciesGroupPlantTypeCreateDto,
  SpeciesGroupPlantTypeDto,
  SpeciesGroupPlantTypeExcelDownloadDto,
  SpeciesGroupPlantTypeUpdateDto,
} from '../proxy/general/dtos/species-group-plant-type';
import { SPECIESGROUPPLANTTYPE_CONFIG, SPECIESGROUPPLANTTYPE_FIELDS } from './species-group-plant-type.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-species-group-plant-type',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpeciesGroupPlantTypeService, ConfirmationService],
  templateUrl: './species-group-plant-type.html',
  styleUrl: './species-group-plant-type.scss',
})
export class SpeciesGroupPlantType extends BaseHierarchicalCrudComponent<
  SpeciesGroupPlantTypeDto,
  SpeciesGroupPlantTypeCreateDto,
  SpeciesGroupPlantTypeUpdateDto,
  SpeciesGroupPlantTypeExcelDownloadDto
> {
  service = inject(SpeciesGroupPlantTypeService);
  config = SPECIESGROUPPLANTTYPE_CONFIG;
  fields = SPECIESGROUPPLANTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpeciesGroupPlantTypeDto): SpeciesGroupPlantTypeUpdateDto {
    return {
      isMain: data.isMain,
      specieGroupId: data.specieGroupId,
      plantTypeId: data.plantTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpeciesGroupPlantType';
  }
}
